import React from 'react'
import classes from './TableV1.module.css'

const TableV1 = ({ children }) => {
    return (
        <div className={classes.tableContainer}>
            <table className={classes.table}>{children}</table>
        </div>
    )
}

export default TableV1
